<template>
  <div class="text-center text-nowrap text-uppercase" :class="{active: isActive, 'not-active': !isActive}">
    <div class="px-2 py-1">{{title}}</div>
  </div>
</template>
<script>
export default {
  name: 'navigation-link',
  props: ['title', 'isActive']
}
</script>
